import { API_BASE_PATH } from '@/config';
import { axios } from '@/lib/axios';
import { Data } from '@/types';

import { User } from '../types';

export const getUser = (): Promise<Data<User>> => axios.get(`${API_BASE_PATH}/user`);
